import WeightScale from './WeightScale';

export default WeightScale;
